<template>
 <transition-group name="fade">
   <measure-intro v-if="journeyplan.measure.content && !currentMeasureIntroDisplayed"
                              :key="journeyplan.journeyplanid + '_intro'"
   ></measure-intro>
   <internal-measure-renderer v-else-if="journeyplan.measure.measure_type==='internal'"
                              :journeyplan="journeyplan"
                              :key="journeyplan.journeyplanid"
                              @complete="measureComplete($event)"
   ></internal-measure-renderer>
   <component v-else-if="validCustomMeasure" :journeyplan="journeyplan" :is="customMeasureComponent"
              key="journeyplan.journeyplanid"
              @complete="measureComplete($event)"></component>
   <div v-else>
     Measure type not supported
   </div>
 </transition-group>
</template>

<script>
  import applicationEventHub from "../../events/applicationEventHub";

  export default {
    props: {
      journeyplan: {Object: true}
    },
    name: "MeasureRenderer",
    components: {
      'measure-intro': () => import('./MeasureIntro'),
      'internal-measure-renderer': () => import('./InternalMeasureRenderer'),
      'custom-job-history': () => import('./custom/jobhistory/JobHistoryMeasure'),
      'custom-qualifications': () => import('./custom/qualifications/QualificationsMeasure'),
      'custom-risk-propensity': () => import('./custom/balloon/BalloonMeasure'),
    },
    computed: {
        //TODO: Below property is in InternalMeasureRenderer. Is this not invalid?
      currentQuestionIndex() {
        return this.$store.state.assessment.currentQuestionIndex;
      },
      validCustomMeasure() {
        return this.journeyplan.measure.measure_type === 'predefined' && this.supportedPredefinedMeasures.includes(this.journeyplan.measure.predefinedmeasureid)
      },
      customMeasureComponent() {
        return 'custom-' + this.journeyplan.measure.predefinedmeasureid;
      },
      videoMonitoring(){
        return this.journeyplan.measure.video_monitoring;
      },
      currentMeasureIntroDisplayed(){
        return !!this.$store.state.assessment.measureIntrosDisplayed[this.journeyplan.journeyplanid];
      }
    },
    data() {
      return {
        supportedPredefinedMeasures: ['job-history', 'qualifications','risk-propensity']
      }
    },
    mounted(){
       this.startVideoMonitoring();
    },
    methods: {
      measureComplete(data) {
          this.stopVideoMonitoring();
          this.$emit('complete',data);
      },
      startVideoMonitoring(){
        if(this.videoMonitoring){
          applicationEventHub.startVideoMonitoring();
        }
      },
      stopVideoMonitoring(){
        if(this.videoMonitoring){
          applicationEventHub.stopVideoMonitoring();
        }
      }
    },
    beforeDestroy() {
      this.stopVideoMonitoring();
    }
  }
</script>

<style scoped>

</style>